import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AllProducts from "./containers/AllProducts/index";
import Products from "./containers/Products/index";
import Users from "./containers/Users/index";
import Subscription from "./containers/Subscription/index";

import Login from "./containers/AdminLogin/index";
import Orders from "./containers/Orders/index";
import Components from "./containers/Components/index";
import Blog from "./containers/Blog";
import { positions, Provider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import Header from "./components/Header";
import "antd/dist/antd.css";

const options = {
  timeout: 5000,
  position: positions.TOP_CENTER,
};

function App() {
  const [token, setToken] = useState();

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, []);

  const changeToken = () => {
    setToken(localStorage.getItem("token"));
  };

  return (
    <Router>
      <Switch>
        <Route
          exact
          path="/"
          render={(props) =>
            !token ? (
              <Login {...props} changeToken={changeToken}></Login>
            ) : (
              <Redirect to="/users/list"></Redirect>
            )
          }
        />
        <Route
          path="/login"
          render={(props) =>
            !token ? (
              <Login {...props} changeToken={changeToken}></Login>
            ) : (
              <Redirect to="/users/list"></Redirect>
            )
          }
        />
        <div style={{ display: "flex" }}>
          {token && <Header setToken={(a) => setToken(a)} />}

          <div
            style={{
              width: "100%",
              paddingTop: 20,
              paddingRight: 50,
              paddingLeft: 50,
            }}
          >
            <Provider template={AlertTemplate} {...options}>
              <Route
                path="/allproducts"
                render={(props) =>
                  !token ? (
                    <Redirect to="/login"></Redirect>
                  ) : (
                    <AllProducts {...props}></AllProducts>
                  )
                }
              />
            </Provider>
            <Provider template={AlertTemplate} {...options}>
              <Route
                path="/orders"
                render={(props) =>
                  !token ? (
                    <Redirect to="/login"></Redirect>
                  ) : (
                    <Orders {...props}></Orders>
                  )
                }
              />
            </Provider>
            <Route
              path="/components"
              render={(props) =>
                token ? (
                  <Components {...props}></Components>
                ) : (
                  <Redirect to="/login"></Redirect>
                )
              }
            />
            <Route
              path="/products"
              render={(props) =>
                token ? (
                  <Products {...props}></Products>
                ) : (
                  <Redirect to="/login"></Redirect>
                )
              }
            />
            <Provider template={AlertTemplate} {...options}>
              <Route
                path="/blog"
                render={(props) =>
                  token ? (
                    <Blog {...props}></Blog>
                  ) : (
                    <Redirect to="/login"></Redirect>
                  )
                }
              />
            </Provider>
            <Provider template={AlertTemplate} {...options}>
              <Route
                path="/users"
                render={(props) => {
                  return token ? (
                    <Users {...props}></Users>
                  ) : (
                    <Redirect to="/login"></Redirect>
                  );
                }}
              />
            </Provider>
            <Provider template={AlertTemplate} {...options}>
              <Route
                path="/subscription"
                render={(props) => {
                  return token ? (
                    <Subscription {...props}></Subscription>
                  ) : (
                    <Redirect to="/login"></Redirect>
                  );
                }}
              />
            </Provider>
          </div>
        </div>
      </Switch>
    </Router>
  );
}

export default App;
